import {
	canManageGlacierArchive,
	glacierArchiveEnabled,
} from '@netx/core-cart-next';
import {currentCartIsNotEmpty} from './currentCartIsNotEmpty';

export const canManageCurrentCartArchive = () =>
	currentCartIsNotEmpty() &&
	glacierArchiveEnabled() &&
	canManageGlacierArchive();

export default canManageCurrentCartArchive;
